import { render } from "./CxAwarenessOverlayControls.vue?vue&type=template&id=e64fbbce"
import script from "./CxAwarenessOverlayControls.vue?vue&type=script&lang=js"
export * from "./CxAwarenessOverlayControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__